import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { ContentContainer } from "./ArticlePreview.component";

gsap.registerPlugin(ScrollTrigger);

const animationLayout = (wrapperRef) => {
    const ref = wrapperRef.current;

    if (!ref) return;

    const photoElement = ref.querySelector("a");
    const descriptionElement = ref.querySelector(`${ContentContainer}`);

    const targets = [photoElement, descriptionElement].filter(Boolean);

    if (targets.length === 0) return;

    // Set initial state (elements are already opacity: 0 in CSS)
    gsap.set(targets, { y: 50 });

    // Create scroll trigger
    ScrollTrigger.create({
        trigger: ref,
        start: "top 60%",
        onEnter: () => {
            gsap.to(targets, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                stagger: 0.2,
                ease: "power2.out",
            });
        },
    });

    // Fallback: if element is already in view when page loads, animate immediately
    const rect = ref.getBoundingClientRect();
    const isInView = rect.top < window.innerHeight * 0.6;

    if (isInView) {
        gsap.to(targets, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.2,
            ease: "power2.out",
        });
    }
};

export { animationLayout };
